import { observer } from "mobx-react-lite";

import { appStore } from "../store/store";

import { getLoginRedirectUrl } from "./apiRoutes";

export const PrivatePage = observer(
  ({ children }: { children: React.ReactNode }) => {
    const loggedIn = appStore.loggedIn;
    if (!loggedIn) {
      window.open(getLoginRedirectUrl(location.pathname), "_self");
      return null;
    }
    return children;
  },
);
